import { Component, OnInit } from "@angular/core";
import { ChartOptions } from "chart.js";

@Component({
  selector: "app-dahsboard",
  templateUrl: "./dahsboard.component.html",
  styleUrls: ["./dahsboard.component.scss"],
})
export class DahsboardComponent implements OnInit {
  // public userByDeviceLabels: Label[] = [
  //   "Desktop 60%",
  //   "Mobile 30%",
  //   "Tablet 10%",
  // ];
  // public chartOptions: ChartOptions = {
  //   // responsive: true,
  //   // maintainAspectRatio: true,
  //   plugins: {},
  //   cutoutPercentage: 60,
  //   layout: { padding: 0 },
  //   legend: {
  //     position: "bottom",
  //     fullWidth: true,
  //     align: "start",

  //     labels: {
  //       boxWidth: 10,
  //       usePointStyle: true,
  //       padding: 8,
  //     },
  //   },
  // };
  // public userByDeviceData: MultiDataSet = [[60, 30, 10]];
  constructor() {}

  ngOnInit() {}
}
